'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  var pathToSchool = ['one', action.sid];

  var pathToSchoolStudents = ['students', action.sid];

  var pathToSchoolRegsiteredFeiseanna = ['feiseanna', action.sid, 'registration'];

  var pathToSchoolReleasedFeiseanna = ['feiseanna', action.sid, 'released'];

  switch (action.type) {
    case 'GET_SCHOOL_START':
      return state.setIn(pathToSchool, (0, _immutable.fromJS)({ loading: true }));

    case 'GET_SCHOOL':
      return state.setIn(pathToSchool, (0, _immutable.fromJS)(action.payload));

    case 'GET_SCHOOL_ERROR':
      return state.setIn(pathToSchool, (0, _immutable.fromJS)({ error: true }));

    case 'GET_STUDENTS_START':
      return state.setIn(pathToSchoolStudents, (0, _immutable.fromJS)({ loading: true }));

    case 'GET_STUDENTS':
      {
        return state.setIn(pathToSchoolStudents, (0, _immutable.fromJS)(action.payload.students.map(function (p) {
          return p.id;
        })));
      }

    case 'GET_STUDENTS_ERROR':
      return state.setIn(pathToSchoolStudents, (0, _immutable.fromJS)({ error: true }));

    case 'GET_REGISTRABLE_FEISEANNA_FOR_SCHOOL':
      return state.setIn(pathToSchoolRegsiteredFeiseanna, (0, _immutable.fromJS)(action.payload.map(function (f) {
        return f.id;
      })));

    case 'GET_RELEASED_FEISEANNA_FOR_SCHOOL':
      return state.setIn(pathToSchoolReleasedFeiseanna, (0, _immutable.fromJS)(action.payload.map(function (f) {
        return f.id;
      })));

    case 'GET_ALL_SCHOOLS':
      return state.setIn(['all'], (0, _immutable.fromJS)(action.payload));

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/schools/index.js
// module id = 707
// module chunks = 0